import React, { useEffect, useState } from "react";
import { Checkbox, Label } from "@rebass/forms";
import { useField } from "formik";
import {InputHelper, InputHelperOptionalParameters} from "./InputHelper";
import {Flex} from "rebass";

export const CheckBoxInput: React.FC<{
  name: string;
  value?: boolean;
  onChange?: (selection: boolean) => void;
  helperParameters?: InputHelperOptionalParameters; 
}> = ({
  name,
  value,
  onChange,
  helperParameters={label: name}
}) => {
  const validate = (value) => {};

  const [field, meta, helpers] = useField({ name, validate });

  const [internalValue, setInternalValue] = useState(false);

  useEffect(()=>{
    if(internalValue != value && value !== undefined){
      helpers.setValue(value);
      setInternalValue(value);
    }
  },[value])

  return (
    <InputHelper helpers={helpers} meta={meta} {...helperParameters}>
      <Label alignItems="center">
        <Checkbox
          
          {...field} onChange={(e) => {
          helpers.setValue(e.target.checked)
          setInternalValue(e.target.checked);
          if(onChange)
            onChange(e.target.checked);
        }} checked={internalValue} />
      </Label>
    </InputHelper>
  );
};
